<script setup>
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import CheckBox from '@/components/Forms/CheckBox.vue'
import { onMounted, ref } from 'vue'
import { useAuthStore } from '@/stores/authStore.js'
import { userApi } from '@/api/User/UserApi.js'
import { Toaster } from '@/models/utils/Toaster.js'
import LoadingSpinner from '@/components/Spinners/LoadingSpinner.vue'

const modules = ref([])
const checkboxRefs = ref([])
const isSaving = ref(false)
const isLoading = ref(false)
const tenantSettings = ref(null)

const toaster = new Toaster()

onMounted(() => {
	isLoading.value = true

	userApi.getTenantById(useAuthStore().getAuth.user().tenant_id, (tenantData) => {
		tenantSettings.value = JSON.parse(tenantData.settings_json)
		modules.value = tenantSettings.value.modules.value

		isLoading.value = false
	})
})

function moduleClicked(route) {
	checkboxRefs.value.forEach((checkbox) => {
		if (checkbox.getInputId() === route) {
			checkbox.performClick()
		}
	})
}

function save() {
	isSaving.value = true

	const updatedModules = modules.value.map((module) => {
		module.enabled = checkboxRefs.value.find((checkbox) => {
			return checkbox.getInputId() === module.route
		}).getIsChecked()
		return JSON.parse(JSON.stringify(module))
	})

	userApi.updateTenantModuleSettings({ modules: updatedModules },
		() => {
			isSaving.value = false
			toaster.success("Module settings updated!")

			setTimeout(() => {
				location.reload()
			}, 750)
		}, () => {
			toaster.error("Module settings failed to update!")
			isSaving.value = false
		}
	)
}

</script>

<template>
	<span>Enable and disable modules</span>

	<LoadingSpinner v-if="isLoading" />

	<div v-else class="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] grid-auto-rows-[1fr] gap-4 mt-4">
		<div
			class="flex h-full min-h-[100px] p-4 rounded border border-t-4 border-primary-darker hover:border-primary-bold-hover cursor-pointer"
			v-for="module in modules"
			:key="module.route"
			@click="moduleClicked(module.route)"
		>
			<div class="flex h-full items-center pointer-events-none">
				<CheckBox
					:input-id="module.route"
					ref="checkboxRefs"
					v-model="module.enabled"
				/>
				<div class="bg-[#B2BBC9] h-full w-[1px] mx-4"/>
			</div>
			<span class="font-medium my-auto w-fit">{{ module.label }}</span>
		</div>
	</div>

	<SubmitButton class="mt-6" label="Save Settings" @click="save" size="small" :disabled="isSaving" :loading="isSaving"/>
</template>